// helper function to convert UTC date string -> YYYY-MM-DD (IST)
 export function toISTDate(dateString) {
  if (!dateString) return null;
  const dt = new Date(dateString);
  const istOffset = 5.5 * 60 * 60 * 1000; // +05:30 in ms
  const istDate = new Date(dt.getTime() + istOffset);

  const day = String(istDate.getDate()).padStart(2, '0');
  const month = String(istDate.getMonth() + 1).padStart(2, '0'); // month is 0-based
  const year = istDate.getFullYear();
    
  return `${year}-${month}-${day}`; // "YYYY-MM-DD"
}